import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContainerComponent } from './components/container/container.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AuthGuard } from './guards/auth.guard';
import { ContainerPublicComponent } from './components/container-public/container-public.component';
import { AuthRedirectGuard } from './guards/authRedirect.guard';

const sharedChildRoutes: Routes = [
  {
    path: 'staff',
    loadChildren: () =>
      import('./routes/staff/staff.module').then((m) => m.StaffModule)
  },
  {
    path: 'report',
    loadChildren: () =>
      import('./routes/report/report.module').then((m) => m.ReportModule)
  },
  {
    path: 'report-s15',
    loadChildren: () =>
      import('./routes/report-s15/report-s15.module').then((m) => m.ReportS15Module)
  }
];

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    canActivate: [AuthRedirectGuard],
    component: ContainerPublicComponent,
  },
  {
    path: 'public',
    component: ContainerPublicComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./routes/home/components/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      ...sharedChildRoutes
    ]
  },
  {
    path: 'private',
    component: ContainerComponent,
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./routes/home/home.module').then(m => m.HomeModule)
      },
      ...sharedChildRoutes
    ]
  },
  {
    path: 'login',
    loadChildren: () => import('./routes/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./routes/reset-password/reset-password.module').then(m => m.ResetPasswordModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./routes/change-password/change-password.module').then(m => m.ChangePasswordModule)
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
